<template>
  <div>
    <loader :loader="sending" />
    <v-data-table :headers="headers" :items="listHistoy" :items-per-page="itemsPerPage" :search="search"
      no-data-text="Sin resultados disponibles" class="mx-5" dense fixed-header height="auto" hide-default-footer>
      <template v-slot:[`item.intepretationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.intepretationDate) }}
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.startDate) }}
      </template>
      <template v-slot:[`item.birads`]="{ item }">
        <v-chip :color="item.colorBirads">
          {{ item.birads }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="isEditableTable(item.idInterpretation)"
              v-if="$utilFront.withPermission($prm.INTERPRETATION_VALIDATE)" >
                <v-icon v-bind="attrs" v-on="on" color="secondary" dense>
                  mdi-checkbox-marked-circle-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Validar</span>
          </v-tooltip>
        <v-menu offset-y :nudge-width="200" :close-on-content-click="false">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <!-- getDataEdit(item) -->
          <v-list dense>
            <v-list-item link @click="downloadViewer(item.idStudy)">
              <v-list-item-icon>
                <v-icon color="amber"> mdi mdi-comment-eye </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Descargar visualizador </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="downloadZIP(item)" v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM_INT)">
              <v-list-item-icon>
                <v-icon color="secondary"> mdi-folder-download </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Descargar DICOM </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="changeViewAddendums(item)">
              <v-list-item-icon>
                <v-icon color="cyan"> mdi-file-image </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Visualizar archivos anexos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <view-image-item :send="() => sending = !sending" :sending="sending" :idStudy="item.idStudy" 
              v-if="$utilFront.withPermission($prm.VIEWER_WEB_INT)"/>

          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogCancelation" persistent max-width="70%" v-if="dialogCancelation">
      <cancelation-modal :dataModal="dataModal" @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation" />
    </v-dialog>
  </div>
</template>

<script>

import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";

import {
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest,
} from "@/core/request";
export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
    getAddendums: Function,
    search: String,
  },
  components: {
    MenuCrud,
    CancelationModal,
    Loader,
    ViewImageItem
  },
  data() {
    return {
      dialogCancelation: false,
      dataModal: {},
      listHistoy: [],
      sending: false,
      headers: [
        {
          text: "Id Interpretación",
          value: "idInterpretation",
          sortable: false,
        },
        {
          text: "Id Estudio",
          value: "idStudy",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "patient",
          align: "center",
          sortable: false,
        },
        {
          text: "Modalidad",
          value: "modality",
          align: "center",
          sortable: false,
        },
        {
          text: "Estudio",
          value: "studyModality",
          align: "center",
          sortable: false,
        },
        {
          text: "BI-RADS",
          value: "birads",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha de interpretación",
          value: "intepretationDate",
          sortable: false,
        },
        {
          text: "Fecha y hora de inicio del estudio",
          value: "startDate",
          sortable: false,
        },
        {
          text: "Intérprete",
          value: "nameInterpreter",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  watch: {
    list: function () {
      this.setlistWithBiradsChanges();
    },
  },
  methods: {
    setlistWithBiradsChanges() {
      this.listHistoy = this.list.map((obj) => {
        obj.birads = obj.birads ? obj.birads : "NA";
        obj.colorBirads = obj.colorBirads ? obj.colorBirads : "nobirad";
        return obj;
      });
    },
    isEditableTable(id) {
      this.get(id, 3);
    },
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    downloadZIP(item) {
      this.sending = true;
      try {
        let data = { idStudy: item.idStudy };
        DownloadZipRequest.downloadImagesDCM(data)
          .then((res) => {
            const url = URL.createObjectURL(
              new Blob([res.data], {
                type: "application/zip",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", item.idStudy + ".zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    exportToPDF(interpretation) {
      let data = {
        idInterpretation: interpretation.idInterpretation,
        interpretationText: "",
        fileName: "Interpretacion",
      };
      ReportPDFRequest.downloadInterpretation(data);
    },
    changeViewAddendums(item) {
      this.sending = true;
      this.objectInterpretation = item;
      this.getAddendums(item, 1);
    },
  },
};
</script>
